module.exports = __webpack_public_path__ + "img/marker_two_blue1.e6e57997.png";